import FeaturedLessons from './FeaturedLessons';

export default FeaturedLessons;
